import IPayment from "models/IPayment";
import ISite from "models/ISite";

export interface IAppState {
    site: Record<string, ISite>;
    loading: boolean;
    error: Error | null;
    preTransaction?: { main?: IPayment; temp?: IPayment };
}
